<form [formGroup]="form" (submit)="submit()" class="login">
  <div class="field">
    <label for="username" class="label">{{shared.res['#Username']}}</label>
    <input #username id="username" class="input" type="text" formControlName="username" /><shared-tooltip [text]="shared.res['#tooltip_recover_username']"></shared-tooltip>
  </div>
  <div style="padding: 1rem 0; text-align: right">
    <button [disabled]="form.invalid" type="submit" class="button">{{shared.res['#SendRecoverPasswordEmail']}}</button>
  </div>
</form>
